  import { useState, useEffect } from "react"
  import { Space } from "antd"
  import { Title } from "ui/Typography"
  import { useTranslation } from "react-i18next"
  import BookingDetailsHeader from "./Header"
  import BookingDetailsBody from "./Body"
  import CrewTab from "./Body/CrewTab"
  import EquipmentTab from "./Body/EquipmentTab"
  import DSTab from "ui/DSTab"
  import PropTypes from "prop-types"
  import { useSelector } from "react-redux"
  import useLoaderWatchers from "modules/loader-watchers/hooks/useLoaderWatchers"
  import { usePermissions } from "hooks/usePermissions"
  import { MODULES, ACTIONS } from "utils/permissions"
  import styles from "./index.module.css"
  import { GuestWaiverDetails } from "./Body/GuestWaiverDetails"
  import { isFeatureEnabled } from "config/features"

  const BookingDetails = ({ isShowTitle = true, onCancelSuccess }) => {
    const { t } = useTranslation()
    const { data } = useSelector((store) => store?.bookings?.clientBookingDetails) || {}
    const [activeTab, setActiveTab] = useState("details")
    const { hasPermission } = usePermissions()
    useLoaderWatchers({ watchers: ["bookings.clientBookingDetails"] })

    const tabItems = [
      { key: "details", label: t("booking.tabs.details") || "Details" },
      { key: "crew", label: t("booking.tabs.crew") || "Crew" },
      hasPermission(MODULES.EQUIPMENT, ACTIONS.VIEW) && { key: "equipment", label: t("booking.tabs.equipment") || "Equipment" }
    ]?.filter(Boolean)

    useEffect(() => {
      const availableTabKeys = tabItems?.map((item) => item.key)
      if (!availableTabKeys.includes(activeTab)) {
        setActiveTab("details")
      }
    }, [tabItems, activeTab])

    const renderTabContent = () => {
      switch (activeTab) {
        case "details":
          return <BookingDetailsBody booking={data} />
        case "crew":
          return <CrewTab booking={data} />
        case "equipment":
          return <EquipmentTab booking={data} />
        default:
          return <BookingDetailsBody booking={data} />
      }
    }

    return (
      <Space direction="vertical" size={32} className="w-full">
        {isShowTitle && <Title level={3}>{t("client.booking_details")}</Title>}
        <BookingDetailsHeader booking={data} className={`${isShowTitle ? "" : styles.bookingdetails}`} />
        <DSTab items={tabItems} activeKey={activeTab} onChange={setActiveTab} />
        {renderTabContent()}
        {isFeatureEnabled('CUSTOM_TEMPLATE') && <GuestWaiverDetails />}
      </Space>
    )
  }

  BookingDetails.propTypes = {
    isShowTitle: PropTypes.bool
  }

  export default BookingDetails
